export class UserMessage {
  receivesEmailNotifications: boolean
  roleId: string

  constructor(receivesEmailNotifications: boolean, roleId: string) {
    this.receivesEmailNotifications = receivesEmailNotifications
    this.roleId = roleId
  }
}
  